import { createRequest } from 'modules/redux-gateway'
import t from './actionTypes'
import * as constants from './constants'

export const loadMessageList = (messages) => ({
  type: t.LOAD_MESSAGE_LIST,
  payload: messages,
})
export const loadMessage = (message) => ({
  type: t.LOAD_MESSAGE,
  payload: message,
})

export const toggleView = () => ({
  type: t.TOGGLE_VIEW,
})

export const getMessage = (messageId) => (dispatch) => {
  const req = dispatch(
    createRequest({
      route: constants.CARRIER_MESSAGE_GET,
      params: {
        Id: messageId,
      },
    })
  )
  return req
}
